import { NotificationType, useNotifyStore } from "~/composables/notify-store";
import { ApiError } from "~/core/utils/api";
import * as Sentry from "@sentry/vue";
import {
  isChunkError,
  reloadForChunkErrorOnce,
} from "~/utils/chunk-reload.utils";

export default defineNuxtPlugin((nuxtApp) => {
  const notifyStore = useNotifyStore();
  nuxtApp.vueApp.config.errorHandler = async (..._args) => {
    const error = _args[0];
    // Stale chunk URLs after a deploy: try a one-shot reload before
    // surfacing the error. The notification/Sentry path stays as a
    // fallback when the reload has already been attempted.
    if (isChunkError(error) && reloadForChunkErrorOnce()) {
      return;
    }
    // ApiError est déjà toastée par l'intercepteur de core/configuration.ts.
    if (!(error instanceof ApiError)) {
      notifyStore.notifyError(error, NotificationType.Danger);
    }
    Sentry.captureException(error);
  };
});
